import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ISupplier, SupplierExportProp } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';
import { QuickFilter } from '../SupplierAccountsListPage';

interface IViewContext extends ITableViewContext<SelectableColumn, ISupplier>, IQuickFilterContext<QuickFilter> {
	exportRecord: Record<SupplierExportProp, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
